/**
 * 平台判定。只用来决定「显示 ⌘ 还是 Ctrl」这类文案，不用来决定功能有无 ——
 * 功能该由能力探测（有没有这个 API）决定，按平台猜会在新设备上出错。
 */

/** 是不是 macOS（含 iPad 上桌面模式的 Safari，它报的也是 Mac）。 */
export function isMac(): boolean {
  if (typeof navigator === 'undefined') return false
  const p = navigator.platform || ''
  return /Mac|iPhone|iPad|iPod/i.test(p) || /Mac OS X/i.test(navigator.userAgent)
}
